import { render, staticRenderFns } from "./RouteMarker.vue?vue&type=template&id=39d65c0e&"
import script from "./RouteMarker.vue?vue&type=script&lang=js&"
export * from "./RouteMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports